import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { ClinicMasterProduct } from '../../../../apis/clinic-master-products/types';
import MasterMedicineSelectorEditor from '../../../FormEditors/MasterMedicineSelectorEditor';

interface ClinicMasterProductEditorProps {
  form: UseFormReturn<ClinicMasterProduct>;
}

const ClinicMasterProductMasterMedicineSelectorEditor = ({ form }: ClinicMasterProductEditorProps) => {
  const isExistingProduct = useIsExistingProduct(form);

  return <MasterMedicineSelectorEditor disabled={!isExistingProduct} control={form.control} name="master_medicine_id" />;
};

const useIsExistingProduct = (form: UseFormReturn<ClinicMasterProduct>) => {
  return !form.getValues('_id');
}

export default ClinicMasterProductMasterMedicineSelectorEditor;
